import { render, staticRenderFns } from "./Stage4.vue?vue&type=template&id=3b8555c3&scoped=true"
import script from "./Stage4.vue?vue&type=script&lang=js"
export * from "./Stage4.vue?vue&type=script&lang=js"
import style0 from "./Stage4.vue?vue&type=style&index=0&id=3b8555c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8555c3",
  null
  
)

export default component.exports